<template>
  <dl :style="{width:isshowlabel?'266px':''}">
    <dt>
      <img
        class="labelIcon"
        v-if="isshowlabel&&index<3"
        :src="require(`../../../../assets/label_no.${index+1}.png`)"
      ></img>
      <img
        :src="item.imageurl"
        alt="图片加载失败"
      />
    </dt>
    <dd>
      <h3 :title="item.name">{{item.name}}</h3>
      <p>
        <span
          :style="css_span"
          :title="`${item.price&&item.price.toFixed(2)}元`"
        ><span :style="{fontSize:'20px',marginRight:'5px'}">{{item.price&&item.price.toFixed(2)}}</span>元</span>
        <button
          :style="css_detail"
          @click="gotobuy(item.id)"
        >
          <a>去购买</a>
        </button>
      </p>
    </dd>
  </dl>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    isshowlabel: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      css_span: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '155px',
        display: 'inline-block'
      },
      css_detail: {
        position: 'absolute',
        right: '0px',
        bottom: '5px'
      },
    };
  },
  mounted () {
  },
  methods: {
    gotobuy (id) {
      this.$emit('gotobuy', id);
    }
  },
}
</script>

<style lang="less" scoped>
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  // filter: gray;
}
dl {
  cursor: default;
  display: inline-block;
  width: 285px;
  margin: 0 8px 32px;
  border-radius: 2px;
  dt {
    height: 160.6px;
    background-color: #ececec;
    position: relative;
    border: 1px solid #ececec;
    img {
      width: 100%;
      height: 100%;
      float: left;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
    .labelIcon {
      width: 76px;
      height: 48px;
      position: absolute;
      left: 13px;
      top: -10px;
    }
  }
  dd {
    border: 1px solid #ececec;
    border-radius: 2px;
    border-top: 0;
    padding: 12px 12px 16px 12px;
    h3 {
      margin-bottom: 10px;
      font-size: 16px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    p {
      position: relative;
      color: #ccc;
      span {
        color: #ff7f0d;
        font-size: 14px;
      }
      button {
        width: 88px;
        height: 30px;
        outline: none;
        border: 0;
        background: #4b7ff0;
        border-radius: 2px;
        font-size: 14px;
        cursor: pointer;
        a {
          color: #fff;
          :hover {
            background: #4b7ff0;
          }
        }
      }
    }
  }
}
</style>
